<template>
  <div
    class="d-flex flex-row align-center pa-1"
    style="flex-wrap: nowrap"
    :key="student.id"
    @click="$emit('change', student)"
  >
    <div v-if="!$vuetify.breakpoint.mobile" class="image-wrapper mr-5">
      <img :src="avatar" alt="" />
    </div>
    <div>
      <router-link v-if="link" :to="getLink" style="text-decoration: none">
        <div
          style="white-space: nowrap"
          :class="{
            'student-link-disabled': !['education_manager', 'super_admin'].includes(role.type)
          }"
        >
          {{ student.name }}
        </div>
      </router-link>

      <div style="white-space: nowrap" v-else>{{ student.name }}</div>
      <div style="white-space: nowrap">{{ student.code }}</div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    student: Object,
    prepend: Object,
    append: Object,
    attendance: Object,
    link: Boolean
  },
  computed: {
    ...mapState('auth', ['user', 'role']),
    avatar() {
      if (this.student.avatar && this.student.avatar.url) {
        const imgUrl = this.student.avatar.url
        if (!/^http/.test(imgUrl)) {
          return `${process.env.VUE_APP_API_ENDPOINT}${imgUrl}`
        } else {
          return imgUrl
        }
      }
      return '/default-avatar.png'
    },
    getLink() {
      if (!['education_manager', 'manager', 'super_admin'].includes(this.user.role.type)) return ''
      return '/student/' + this.student.id
    }
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    object-fit: cover;
  }
}
.student-link-disabled {
  color: black;
}
</style>
